import React, { useState, useEffect } from 'react';
import Meta from '../components/Meta';
import AuthSection from '../components/AuthSection';
import { useRouter } from '../util/router';
import PageLoader from '../components/PageLoader';

function AuthPage() {
  const router = useRouter();
  const [isReady, setIsReady] = useState(false);

  const useMicrosoftLogin = String(window.location.hostname).match(/buckeye./);

  const providers = useMicrosoftLogin ? ['microsoft'] : null;

  // Wait for Firebase to be fully initialized before rendering auth components
  // This prevents race conditions with Google API script loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  // Show loading state while Firebase initializes
  if (!isReady) {
    return <PageLoader />;
  }

  return (
    <>
      <Meta title="Auth" />
      <AuthSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        type={router.query.type}
        providers={providers}
        afterAuthPath={router.query.next || '/dashboard'}
      />
    </>
  );
}

export default AuthPage;
